var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconly4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80769 7.88571C5.80769 5.73969 7.56411 4 9.73077 4C11.8974 4 13.6538 5.73969 13.6538 7.88571C13.6538 10.0317 11.8974 11.7714 9.73077 11.7714C7.56411 11.7714 5.80769 10.0317 5.80769 7.88571Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25123 13.5261L7.41563 13.5001C8.94935 13.2577 10.5122 13.2577 12.0459 13.5001L12.2103 13.5261C14.3714 13.8677 15.9615 15.714 15.9615 17.8816C15.9615 19.0516 15.004 20 13.8228 20H5.63874C4.45755 20 3.5 19.0516 3.5 17.8816C3.5 15.714 5.09016 13.8677 7.25123 13.5261Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2692 4C14.8869 4 14.5769 4.307 14.5769 4.68571C14.5769 5.06442 14.8869 5.37143 15.2692 5.37143C16.6712 5.37143 17.8077 6.49711 17.8077 7.88571C17.8077 9.27432 16.6712 10.4 15.2692 10.4C14.8869 10.4 14.5769 10.707 14.5769 11.0857C14.5769 11.4644 14.8869 11.7714 15.2692 11.7714C17.4359 11.7714 19.1923 10.0317 19.1923 7.88571C19.1923 5.73969 17.4359 4 15.2692 4Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4149 13.4916C16.0326 13.4916 15.7226 13.7986 15.7226 14.1773C15.7226 14.556 16.0326 14.863 16.4149 14.863H17.3086C17.3829 14.863 17.4573 14.8688 17.5306 14.8804C19.0197 15.1158 20.1154 16.388 20.1154 17.8816C20.1154 18.2942 19.7778 18.6286 19.3613 18.6286H17.4753C17.0929 18.6286 16.783 18.9356 16.783 19.3143C16.783 19.693 17.0929 20 17.4753 20H19.3613C20.5425 20 21.5 19.0516 21.5 17.8816C21.5 15.714 19.9098 13.8677 17.7488 13.5261C17.6032 13.5031 17.4559 13.4916 17.3086 13.4916H16.4149Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconly4);
export default __webpack_public_path__ + "static/media/Iconly4.408ace221a52e074c32ab585e36820e7.svg";
export { ForwardRef as ReactComponent };